module.exports = __webpack_public_path__ + "res/ic_menu_game_s.7e5d2dccbfb656728f29341b3fd1fdfe.png";